import NavbarLeft from "./NavbarLeft" ;
import NavbarRight from "./NavbarRight";
import ResponsiveNavbarLeft from "./ResponsiveNavbarLeft";
import ResponsiveNavbarRight from "./ResponsiveNavbarRight";
import React, { useState, useEffect } from "react";
import { axiosReq } from "../../../commons/axiosReq";

const Navbar2 = () => {
        const [cats, setCats] = useState();
        
         const GetData = async () => {
             
                const mainCats = await axiosReq("Admins/GetCategories", "get");
                console.log(mainCats)
                setCats(mainCats?.data)
            }
        useEffect(() => {
    
            GetData();
        }, []);
        // if (!cats) {
        //     return <div></div>;
        //   }
    return(
       <>
        <div className="flex bg-mainColor2 w-full justify-between items-center pt-10 pb-[34px] px-[70px] lg:hidden xl:px-[10px]">
            <NavbarRight data={cats}/>
            <NavbarLeft data={cats}/>
        </div>
        <div className="hidden  bg-mainColor2 w-full lg:justify-between lg:items-center pt-5 pb-5 px-[20px] lg:flex">
            <ResponsiveNavbarRight data={cats}/>
            <ResponsiveNavbarLeft data={cats}/>

        </div>
       </>
    )
}

export default Navbar2;